var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 26.2982H12.5C10.1741 26.2982 9.0111 26.2982 8.06477 26.5852C5.9341 27.2316 4.26674 28.8989 3.62041 31.0296C3.33334 31.9759 3.33334 33.1389 3.33334 35.4648M31.6667 35.4648V25.4648M26.6667 30.4648H36.6667M24.1667 12.9648C24.1667 17.107 20.8088 20.4648 16.6667 20.4648C12.5245 20.4648 9.16668 17.107 9.16668 12.9648C9.16668 8.82271 12.5245 5.46484 16.6667 5.46484C20.8088 5.46484 24.1667 8.82271 24.1667 12.9648Z",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserPlus);
export default __webpack_public_path__ + "static/media/addUserPlus.ce7450b69ed588ce96f404aecc7c11f4.svg";
export { ForwardRef as ReactComponent };